import { useCallback, useMemo } from "react";
import { enviarColetaPrevia } from "@services";
import { somenteDigitos } from "@utils";

const extrairBase64 = (dataUrl) => dataUrl?.split(",")[1];

export const useColetaPrevia = (idSolicitacao, cpfParametro) => {
  const cpf = useMemo(
    () => somenteDigitos(cpfParametro) || null,
    [cpfParametro],
  );

  const enviar = useCallback(
    async (tipoPendencia, foto) => {
      if (!idSolicitacao) {
        throw new Error("Não foi possível identificar a solicitação.");
      }

      if (!cpf) {
        throw new Error("Não foi possível identificar o CPF do requerente.");
      }

      return enviarColetaPrevia({
        idSolicitacao,
        cpf,
        tipoPendencia,
        documentoBase64: extrairBase64(foto),
      });
    },
    [cpf, idSolicitacao],
  );

  return { cpf, enviar };
};
